import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "./LogoAppleTreeHD.svg";

const ESGSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const requestId = location.state?.requestId;

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <img src={logo} alt="AppleTree Logo" style={styles.logo} />
        
        <div style={styles.successIcon}>✓</div>
        <h2 style={styles.title}>Thank You!</h2>
        
        <p style={styles.message}>
          Your ESG questionnaire has been submitted successfully.
        </p>
        
        {requestId && (
          <div style={styles.requestIdBox}>
            <strong>Request ID:</strong> {requestId}
          </div>
        )}
        
        <p style={styles.subMessage}>
          We will review your submission and get back to you soon.
        </p>
        
        <button
          onClick={() => navigate("/")}
          style={styles.backButton}
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#ecf0f1",
    padding: "20px",
  },
  card: {
    backgroundColor: "white",
    padding: "40px",
    borderRadius: "8px",
    boxShadow: "0 2px 20px rgba(0,0,0,0.1)",
    textAlign: "center",
    maxWidth: "500px",
    width: "100%",
  },
  logo: {
    maxWidth: "150px",
    marginBottom: "20px",
  },
  successIcon: {
    fontSize: "60px",
    color: "#27ae60",
    marginBottom: "20px",
  },
  title: {
    color: "#2c3e50",
    fontSize: "28px",
    fontWeight: "600",
    marginBottom: "15px",
  },
  message: {
    color: "#7f8c8d",
    fontSize: "16px",
    marginBottom: "20px",
  },
  requestIdBox: {
    backgroundColor: "#ecf0f1",
    padding: "15px",
    borderRadius: "4px",
    marginBottom: "20px",
    fontSize: "14px",
    color: "#2c3e50",
  },
  subMessage: {
    color: "#95a5a6",
    fontSize: "14px",
    marginBottom: "30px",
  },
  backButton: {
    padding: "12px 30px",
    backgroundColor: "#27ae60",
    color: "white",
    border: "none",
    borderRadius: "4px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background-color 0.3s",
  },
};

export default ESGSuccess;
